import { render, staticRenderFns } from "./WhatsAppLogs.vue?vue&type=template&id=4fa5cd55&scoped=true"
import script from "./WhatsAppLogs.vue?vue&type=script&lang=js"
export * from "./WhatsAppLogs.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppLogs.vue?vue&type=style&index=0&id=4fa5cd55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5cd55",
  null
  
)

export default component.exports